import { render, staticRenderFns } from "./EditMultiDomain.vue?vue&type=template&id=95c0b4ca&"
import script from "./EditMultiDomain.vue?vue&type=script&lang=js&"
export * from "./EditMultiDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports